import { FocusMonitor } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MaskitoDirective, MaskitoPattern } from '@maskito/angular';
import { TunnelSanteI18nModule } from '@wz-i18n';
import { TunnelSanteUiModule } from '@wz-ui';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import {
  wzFormsExportedComponents,
  wzFormsExportedDirectives,
  wzFormsExportedPipes,
  wzFormsMaterialExports,
} from './wz-forms/wz-forms-exports';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TunnelSanteI18nModule,
    TunnelSanteUiModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    NgxMaskDirective,
    ...wzFormsMaterialExports,
    MaskitoDirective,
    MaskitoPattern,
  ],
  declarations: [
    ...wzFormsExportedComponents,
    ...wzFormsExportedPipes,
    ...wzFormsExportedDirectives,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    MaskitoDirective,
    MaskitoPattern,
    ...wzFormsExportedComponents,
    ...wzFormsExportedPipes,
    ...wzFormsExportedDirectives,
    ...wzFormsMaterialExports,
  ],
  providers: [
    provideNgxMask(),
    FocusMonitor,
    ShowOnDirtyErrorStateMatcher,
    {
      provide: ErrorStateMatcher,
      useExisting: ShowOnDirtyErrorStateMatcher,
    },
  ],
})
export class TunnelSanteFormsModule {}
